import { ScheduleDataProvider } from '../context/ScheduleDataProvider';
import Schedule from './Schedule';

export default function SchedulePage() {
  return (
    <ScheduleDataProvider>
      <Schedule />
    </ScheduleDataProvider>
  );
}
